import Footer from "../components/Footer";
import HeaderP from "../components/HeaderP";

const Privacity = () => {
    return (
        <div>
            <HeaderP />
            <section className="pt-20 px-6 md:px-32 grid grid-cols-1 gap-8 place-content-center place-items-center text-gray-700">
                <h1 className="text-teal-500 text-3xl font-bold text-center">
                    Política de privacidad
                </h1>
                <div className="w-20 h-1 bg-teal-500 mb-6" />

                <p className="text-sm text-gray-500">
                    Última actualización: 10 de octubre de 2021
                </p>

                <p>
                    Esta Política de privacidad describe nuestras políticas y procedimientos sobre la recopilación, el uso y la divulgación de su información cuando utiliza el Servicio y le informa sobre sus derechos de privacidad y cómo la ley lo protege.
                </p>
                <p>
                    Usamos sus datos personales para proporcionar y mejorar el Servicio. Al usar el Servicio, acepta la recopilación y el uso de información de acuerdo con esta Política de privacidad.
                </p>

                {/* Interpretación y Definiciones */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Interpretación y Definiciones
                </h2>
                <h3 className="text-xl font-bold mt-4">Interpretación</h3>
                <p>
                    Las palabras cuya letra inicial está en mayúscula tienen significados definidos bajo las siguientes condiciones. Las siguientes definiciones tendrán el mismo significado, independientemente de que aparezcan en singular o en plural.
                </p>

                <h3 className="text-xl font-bold mt-4">Definiciones</h3>
                <ul className="list-disc list-inside space-y-2">
                    <li><strong>Cuenta:</strong> Una cuenta única creada para que Usted acceda a nuestro Servicio.</li>
                    <li><strong>Afiliado:</strong> Entidad que controla, es controlada o está bajo control común con otra parte.</li>
                    <li><strong>Aplicación:</strong> El software proporcionado por la Compañía, llamado <em>GDA Magazine</em>.</li>
                    <li><strong>Compañía:</strong> GDA Magazine (también "Nosotros").</li>
                    <li><strong>País:</strong> México.</li>
                    <li><strong>Dispositivo:</strong> Cualquier equipo que pueda acceder al Servicio.</li>
                    <li><strong>Datos personales:</strong> Información que identifica o hace identificable a una persona.</li>
                    <li><strong>Servicio:</strong> Se refiere a la Aplicación.</li>
                    <li><strong>Proveedor de servicios:</strong> Terceros que procesan datos en nombre de la Compañía.</li>
                    <li><strong>Datos de uso:</strong> Información recopilada automáticamente por el uso del Servicio.</li>
                    <li><strong>Usted:</strong> Persona que accede al Servicio o en cuyo nombre se accede.</li>
                </ul>

                {/* Recopilación y uso */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Recopilación y Uso de sus Datos Personales
                </h2>

                <h3 className="text-xl font-bold mt-4">Tipos de datos recopilados</h3>
                <p><strong>Información personal:</strong></p>
                <ul className="list-disc list-inside space-y-2">
                    <li>Dirección de correo electrónico</li>
                    <li>Nombre y apellido</li>
                    <li>Datos de uso</li>
                </ul>

                <p><strong>Datos de uso:</strong> Se recopilan automáticamente e incluyen dirección IP, navegador, páginas visitadas, fecha/hora de visita, entre otros.</p>

                <p><strong>Información de la aplicación:</strong> Con su permiso, podemos recopilar imágenes y datos de su dispositivo para ofrecer funcionalidades específicas.</p>

                {/* Uso de datos */}
                <h3 className="text-xl font-bold mt-4">Uso de sus Datos Personales</h3>
                <ul className="list-disc list-inside space-y-2">
                    <li>Proveer y mantener nuestro Servicio.</li>
                    <li>Gestionar su Cuenta como usuario.</li>
                    <li>Ejecutar contratos de compra de productos o servicios.</li>
                    <li>Contactarlo vía email, llamadas, SMS o notificaciones.</li>
                    <li>Ofrecerle noticias, ofertas y promociones.</li>
                    <li>Atender y gestionar sus solicitudes.</li>
                    <li>Analizar datos, tendencias y mejorar el Servicio.</li>
                </ul>

                {/* Retención */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Retención de Datos Personales
                </h2>
                <p>
                    Conservaremos sus datos personales solo durante el tiempo necesario para cumplir los fines establecidos en esta Política de privacidad y según las obligaciones legales aplicables.
                </p>

                {/* Transferencia */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Transferencia de Datos Personales
                </h2>
                <p>
                    Su información puede transferirse y mantenerse en computadoras fuera de su país, donde las leyes de protección de datos pueden diferir.
                </p>

                {/* Divulgación */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Divulgación de Datos Personales
                </h2>
                <p>Podemos divulgar sus datos en casos de:</p>
                <ul className="list-disc list-inside space-y-2">
                    <li>Transacciones de negocios (fusión, adquisición, venta de activos).</li>
                    <li>Cumplimiento de la ley.</li>
                    <li>Proteger derechos, seguridad y prevenir irregularidades.</li>
                </ul>

                {/* Seguridad */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Seguridad
                </h2>
                <p>
                    Utilizamos medidas comercialmente aceptables para proteger sus datos personales, aunque ningún método es 100 % seguro.
                </p>

                {/* Niños */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Privacidad de los Niños
                </h2>
                <p>
                    No recopilamos intencionalmente información de menores de 13 años. Si descubrimos que lo hemos hecho, eliminaremos dichos datos.
                </p>

                {/* Enlaces */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Enlaces a Otros Sitios
                </h2>
                <p>
                    Nuestro Servicio puede contener enlaces a sitios de terceros. No somos responsables de sus políticas de privacidad.
                </p>

                {/* Cambios */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Cambios en esta Política
                </h2>
                <p>
                    Podemos actualizar esta Política ocasionalmente. Notificaremos cambios mediante la publicación de la nueva versión y la fecha de “Última actualización”.
                </p>

                {/* Contacto */}
                <h2 className="text-2xl font-semibold text-teal-500 mt-8">
                    Contáctenos
                </h2>
                <p>
                    Si tiene preguntas sobre esta Política de privacidad, puede contactarnos al correo:{" "}
                    <a href="mailto:grupodeautores@gmail.com" className="text-teal-500 font-semibold">
                        grupodeautores@gmail.com
                    </a>
                </p>
            </section>
            <Footer />
        </div>
    );
};

export default Privacity;
